import React, { Component } from 'react';

const videoBg = 'https://lagunaproperty.com/vdo/Cassia_Timelapse.mp4';

export default class Mission extends Component {
  render() {
    return (
      <div className="aboutus-page-mission">
        <video className="vdo-bg" autoPlay muted loop>
          <source src={videoBg} type="video/mp4" />
        </video>
        <div className="container-content">
          <div className="content">
            <h2>Our mission</h2>
            <p>
              <strong>Laguna Property is the property development arm of Laguna Resorts &amp; Hotels</strong>, a publicly listed company that traces
              its history back to the early 1980s, with the land acquisition and resort development of what is now Laguna Phuket, at the time Asia's
              first integrated resort complex.
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AboutUs/Mission.js